import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function BestTechGearPicksLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M21.3332 2.66675H7.99984C3.73317 2.66675 2.6665 3.73341 2.6665 8.00008V15.8668C2.7065 19.9068 3.8265 20.9334 7.99984 20.9334H10.9998V25.6667H6.59985C6.05319 25.6667 5.59985 26.1201 5.59985 26.6667C5.59985 27.2134 6.05319 27.6667 6.59985 27.6667H16.3332C16.1332 27.1467 16.0398 26.4934 16.0265 25.6667H12.9998V20.9334H16.0265V15.8668V14.1201C16.0265 11.2668 16.9732 10.3201 19.8265 10.3201H25.5332C25.9465 10.3201 26.3332 10.3467 26.6665 10.3867V8.00008C26.6665 3.73341 25.5998 2.66675 21.3332 2.66675Z"
          fill="white"
        />
        <path
          d="M26.6669 10.3867C26.3335 10.3467 25.9469 10.3201 25.5335 10.3201H19.8269C16.9735 10.3201 16.0269 11.2668 16.0269 14.1201V25.6667C16.0402 26.4934 16.1335 27.1467 16.3335 27.6667C16.8002 28.8801 17.8535 29.3334 19.8269 29.3334H25.5335C28.3869 29.3334 29.3335 28.3868 29.3335 25.5334V14.1201C29.3335 11.6801 28.6402 10.6401 26.6669 10.3867ZM22.6802 13.4535C23.8402 13.4535 24.7735 14.3867 24.7735 15.5467C24.7735 16.7067 23.8402 17.6401 22.6802 17.6401C21.5202 17.6401 20.5869 16.7067 20.5869 15.5467C20.5869 14.3867 21.5202 13.4535 22.6802 13.4535ZM22.6802 25.5334C21.1069 25.5334 19.8269 24.2534 19.8269 22.6801C19.8269 22.0268 20.0535 21.4134 20.4269 20.9334C20.9469 20.2668 21.7602 19.8267 22.6802 19.8267C23.4002 19.8267 24.0535 20.0934 24.5469 20.5201C25.1469 21.0534 25.5335 21.8268 25.5335 22.6801C25.5335 24.2534 24.2535 25.5334 22.6802 25.5334Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M25.5333 22.68C25.5333 24.2533 24.2533 25.5334 22.68 25.5334C21.1067 25.5334 19.8267 24.2533 19.8267 22.68C19.8267 22.0267 20.0533 21.4133 20.4267 20.9333C20.9467 20.2667 21.76 19.8267 22.68 19.8267C23.4 19.8267 24.0533 20.0934 24.5467 20.52C25.1467 21.0534 25.5333 21.8267 25.5333 22.68Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M22.6803 17.64C23.8364 17.64 24.7736 16.7027 24.7736 15.5466C24.7736 14.3905 23.8364 13.4534 22.6803 13.4534C21.5241 13.4534 20.5869 14.3905 20.5869 15.5466C20.5869 16.7027 21.5241 17.64 22.6803 17.64Z"
          fill="white"
        />
      </svg>
      <span>Best Tech Gear Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
